module.exports = __webpack_public_path__ + "static/media/click-city-logo.2031b94a.png";